import { LayoutRenderLayoutItemOptions } from '../../../models/cv-layout-render.model';

export class PanoramaTourOptions extends LayoutRenderLayoutItemOptions {
	filter?: string[];
	readDescriptionFromData?: {
        key: string | string[];
        separator?: string;
    };
	photosInData?: boolean;

	constructor() {
		super();
		this.photosInData = true;
	}
}